import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logWarn } from './logger';

/**
 * Fire a POST /api/pageview every time the route path changes.
 * Admin paths are skipped on the backend too, but we bail early here to avoid noise.
 */
export function useAnalytics() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (!pathname || pathname.startsWith('/admin')) return;
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;

    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    const body = JSON.stringify({
      path: pathname,
      referrer: document.referrer || null,
    });

    // Use sendBeacon when available (fire-and-forget, survives navigation)
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(`${apiUrl}/api/pageview`, blob);
        return;
      }
    } catch (err) {
      logWarn('sendBeacon failed, falling back to fetch:', err?.message || err);
    }

    fetch(`${apiUrl}/api/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch((err) => logWarn('Pageview fetch failed:', err?.message || err));
  }, [pathname]);
}
